import {Injectable, NgZone} from '@angular/core';
import {ViewService} from "./view.service";
import {Subject, BehaviorSubject} from "rxjs";
import {GoogleMapsService} from "./google-map.service";
import {
  Partecipant
} from "../../classes/common/partecipant";
import {Poi} from "../../classes/common/poi";
import {DataService} from "src/app/services/common/data.service";
import {TrackerGps} from "src/app/classes/common/tracker-gps";
import {Utility} from "src/app/classes/common/utility";
import {TranslateService} from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class MainMapService {

  readonly MAP_NAME: string = "main";

  static infotrafficLabel: string; // label etichetta infotraffico
  static infotrafficImage: string; // Url immagine anteprima infotraffico
  static roadMapLabel: string; // label etichetta read map
  static roadMapImage: string; // Url immagine anteprima road map
  static satelliteMapLabel: string; // label etichetta mappa satellitare
  static satelliteMapImage: string; // Url immagine anteprima mappa satellitare
  static isMobile: boolean;
  static guideMarkerAssigned: boolean = false;

  mapType: string;
  map: any;
  participantMarkers: any[] = [];
  poiMarkers: any[] = [];
  infoWindow: any;

  infoWindowGsmMarker: any;

  circle: any;
  /** Poligono evidenziato in mappa per POI di tipo `area_type='polygon'`.
   *  Disegnato/rimosso dalla stessa coppia drawCirclePoi/removeCirclePoi del cerchio. */
  poiPolygon: any;
  /** _id del POI per cui e' attualmente disegnata l'area (cerchio o poligono).
   *  Serve a ripulire l'area quando si elimina il POI selezionato. */
  private selectedAreaPoiId: string = null;

  /** Quando true, disegna in mappa le aree (cerchio o polygon) di TUTTI i POI
   *  visibili — non solo quello selezionato. Controllato dal flag in marker-settings
   *  e persistito in storage `mapOptions`. */
  static alwaysShowPoiAreas: boolean = false;
  /** Aree "sempre visibili" indicizzate per poi._id (Circle o Polygon). */
  private allPoiAreas: { [poiId: string]: any } = {};
  selectedMarker: any;

  onSelectMarker = new Subject<any>();
  onSelectMarker$ = this.onSelectMarker.asObservable();

  onUpdateAutoFollow = new Subject<any>();
  onUpdateAutoFollow$ = this.onUpdateAutoFollow.asObservable();

  buttonMapType_1: any;
  buttonMapType_2: any;
  infoTrafficEnabled: boolean = true;
  lastAutoZoomTime: number = 0;
  autoZoomPausedByUser: boolean = false;
  cambioDaCodice: boolean = false;


  needResize: boolean;

  static currentZoom: number;
  static currentCenter: any;
  static currentInfotraffic: boolean;
  static currentMapType:  string;
  static initCount: number = -1;

  static labelVisible: boolean = true;
  static popupVisible: boolean = true;
  static marginSize: number = 4;
  static autoFollow: boolean = undefined;
  static primoAvvio: boolean = false;

  expandedParticipantId: string | null = null;
  expandedPoiId: string | null = null;

  private preExpandZoom: number | null = null;

  onExpandStateChange = new Subject<any>();
  onExpandStateChange$ = this.onExpandStateChange.asObservable();

  private activeAccuracyCircle: any = null;
  private activeAccuracyInfoWindow: any = null;

  public showContextDuringExpand: boolean = false;

  private activeCellMarker: any = null;
  private tempMarker: any = null;
  private tempInfoWindow: any = null;

  private onMapUserInteraction = new Subject<void>();
  onMapUserInteraction$ = this.onMapUserInteraction.asObservable();


  constructor(
    public googleMaps: GoogleMapsService,
    private data: DataService,
    private translate: TranslateService,
    private zone: NgZone
  ) {
  }

  async initMap(
    mapType: string,
    infotrafficLabel: string,
    infotrafficImage: string,
    roadMapLabel: string,
    roadMapImage: string,
    satelliteMapLabel: string,
    satelliteMapImage: string,
    lightInit: boolean,
    isMobile?: boolean
  ) {
    MainMapService.infotrafficLabel = infotrafficLabel;
    MainMapService.infotrafficImage = infotrafficImage;
    MainMapService.roadMapLabel = roadMapLabel;
    MainMapService.roadMapImage = roadMapImage;
    MainMapService.satelliteMapLabel = satelliteMapLabel;
    MainMapService.satelliteMapImage = satelliteMapImage;
    MainMapService.isMobile = isMobile;

    this.mapType = mapType;
    this.clearMap();
    await this.googleMaps.isReady(); // Attende che google sia caricato
    this.googleMaps.clearMap();
    this.map = this.googleMaps.getMap();
    let mapContainer: any = document.getElementById("main-map");
    if(mapContainer){
      mapContainer.appendChild(this.googleMaps.getDivMap());
      this.googleMaps.setCurrentMap(this.MAP_NAME);
    }

    const dragListener = GoogleMapsService.google.maps.event.addListener(this.map, 'dragstart', () => {
      this.onMapUserInteraction.next();
    });
    this.googleMaps.addListener(dragListener, this.MAP_NAME);

    const listenerRef: any = this.map.addListener('rightclick', (event: any) => {
      if(this.expandedParticipantId || this.expandedPoiId){
        return;
      }
      if (!this.cambioDaCodice && (!this.expandedParticipantId || !this.expandedPoiId) ) {
        this.pauseAutoZoomByUser(); // azione dell’utente
      }
      this.drawSelectMarker(event.latLng.lat(), event.latLng.lng());
    });
    this.googleMaps.addListener(listenerRef, this.MAP_NAME);
    const listenerClick: any = this.map.addListener('click', (event: any) => {

      if (!this.cambioDaCodice && (!this.expandedParticipantId || !this.expandedPoiId) ) {
        this.pauseAutoZoomByUser(); // azione dell’utente
      }
      this.googleMaps.unspiderfyMarkers(MainMapService.popupVisible);
      if(this.selectedMarker) this.selectedMarker.map = null;
      this.closeInfoWindow();
    });
    this.googleMaps.addListener(listenerClick, this.MAP_NAME);
    const listenerZoomChange: any = this.map.addListener("zoom_changed", () => {
      MainMapService.currentZoom = this.map.getZoom();
    });
    this.googleMaps.addListener(listenerZoomChange, this.MAP_NAME);
    const listenerCenterChange: any = this.map.addListener("center_changed", (event: any) => {
      if (!this.cambioDaCodice && (!this.expandedParticipantId || !this.expandedPoiId) ) {
        this.pauseAutoZoomByUser(); // azione dell’utente
      }
      MainMapService.currentCenter = this.map.getCenter();
    });
    this.googleMaps.addListener(listenerCenterChange, this.MAP_NAME);
    if(!lightInit){
      this.infoWindow = new GoogleMapsService.google.maps.InfoWindow();
      this.infoWindow.setContent(document.getElementById("main-map-infowindow") as HTMLElement);
      this.infoWindow.setZIndex(4000);
    }
    MainMapService.initCount++;
    this.map.setOptions({
      center: MainMapService.currentCenter || {lat: 41.8933203, lng: 12.4829321},
      zoom: MainMapService.currentZoom || 6,
      fullscreenControl: false,
      zoomControl: !MainMapService.isMobile,
      streetViewControl: false,
      mapTypeControl: false,
      clickableIcons: false,
      mapTypeId: MainMapService.currentMapType || GoogleMapsService.google.maps.MapTypeId.ROADMAP
    });
    if(MainMapService.currentInfotraffic){
      this.googleMaps.enableInfoTraffic();
    }else{
      this.googleMaps.disableInfoTraffic();
    }
    this.setMapTypeControls();
  }

  clearMap(){
    this.selectedMarker = undefined;
    this.poiMarkers = [];
    this.participantMarkers = [];
  }

  pauseAutoZoomByUser() {
    if (!MainMapService.autoFollow || this.expandedParticipantId || this.expandedPoiId) return;
    this.autoZoomPausedByUser = true;
    this.onUpdateAutoFollow.next({pause: true, status: MainMapService.autoFollow});
  }

  changeZoom(delta: number){
    let zoom: number = this.map.getZoom();
    this.map.setZoom(zoom + delta);
  }

  resizeMap(){
    let bounds: any = new GoogleMapsService.google.maps.LatLngBounds();
    for (let i = 0; i < this.participantMarkers.length; i++) {
      const marker = this.participantMarkers[i];

      if (marker.map && marker.position) {
        bounds.extend(marker.position);
      }
    }
    for (let i = 0; i < this.poiMarkers.length; i++) {
      const marker = this.poiMarkers[i];

      if (marker.map && marker.position) {
        bounds.extend(marker.position);
      }
    }
    if(!bounds.isEmpty()){
      this.map.fitBounds(bounds, 50);
      setTimeout(() => {
        if(this.map.getZoom() > 16){
          this.map.setZoom(16);
        }
      }, 200)
    }
  }

  setCenter(lat: number, lng: number){
    this.map.setCenter({lat: lat, lng: lng});
  }

  setMapType(type: string){
    this.map.setMapTypeId(type);
  }

  getMapType(){
    return this.map.getMapTypeId();
  }

  private async setMapTypeControls(){
    // console.log('main-map service setMapTypeControls()');

    const size: string = MainMapService.isMobile ? '54px' : '75px';
    if(!this.buttonMapType_1){
      this.buttonMapType_1 = document.createElement('div');
      let controlUIMap = document.createElement('div');
      controlUIMap.style.height = size;
      controlUIMap.style.width = size;
      controlUIMap.style.background = "linear-gradient(0deg,rgba(0,0,0,0.3),rgba(0,0,0,0.3)),url(" + MainMapService.satelliteMapImage + ")";
      controlUIMap.style.backgroundSize = size + " " + size;
      controlUIMap.style.border = '2px solid #fff';
      controlUIMap.style.borderRadius = '5px';
      controlUIMap.style.cursor = 'pointer';
      controlUIMap.style.marginRight = MainMapService.isMobile ? '8px' : '10px';
      this.buttonMapType_1.style.marginBottom = "5px";
      this.buttonMapType_1.appendChild(controlUIMap);
      let controlTexMap = document.createElement('div');
      controlTexMap.style.color = "#fff";
      controlTexMap.style.fontFamily = 'Roboto,Arial,sans-serif';
      controlTexMap.style.fontSize = MainMapService.isMobile ? '8px' : '10px';
      controlTexMap.style.lineHeight = '38px';
      controlTexMap.style.paddingLeft = '5px';
      controlTexMap.style.paddingRight = '5px';
      controlTexMap.style.marginTop = MainMapService.isMobile ? '20px' : '40px';
      controlTexMap.style.textOverflow = 'ellipsis';
      controlTexMap.style.overflow = 'hidden';
      controlTexMap.style.whiteSpace = 'nowrap';
      controlTexMap.innerHTML = MainMapService.satelliteMapLabel;
      this.buttonMapType_1.addEventListener('click', () => {
        let mapTypeId: string = this.map.getMapTypeId();
        if (mapTypeId == GoogleMapsService.google.maps.MapTypeId.HYBRID) {
          controlUIMap.style.background = "linear-gradient(0deg,rgba(0,0,0,0.3),rgba(0,0,0,0.3)),url(" + MainMapService.satelliteMapImage + ")";
          controlUIMap.style.backgroundSize = size + " " + size;
          controlTexMap.innerHTML = MainMapService.satelliteMapLabel;
          MainMapService.currentMapType = GoogleMapsService.google.maps.MapTypeId.ROADMAP;
        } else {
          controlUIMap.style.background = "linear-gradient(0deg,rgba(0,0,0,0.3),rgba(0,0,0,0.3)),url(" + MainMapService.roadMapImage + ")";
          controlUIMap.style.backgroundSize = size + " " + size;
          controlTexMap.innerHTML = MainMapService.roadMapLabel;
          MainMapService.currentMapType = GoogleMapsService.google.maps.MapTypeId.HYBRID;
        }
        this.map.setMapTypeId(MainMapService.currentMapType);
      });
      controlUIMap.appendChild(controlTexMap);
    }
    if(!this.buttonMapType_2){
      this.buttonMapType_2 = document.createElement('div');
      let controlUITraffic = document.createElement('div');
      controlUITraffic.style.height = size;
      controlUITraffic.style.width = size;
      controlUITraffic.style.background = "linear-gradient(0deg,rgba(0,0,0,0.3),rgba(0,0,0,0.3)),url(" + MainMapService.infotrafficImage + ")";
      controlUITraffic.style.backgroundSize = size + " " + size;
      controlUITraffic.style.border = '2px solid #fff';
      controlUITraffic.style.borderRadius = '5px';
      controlUITraffic.style.cursor = 'pointer';
      controlUITraffic.style.marginRight = MainMapService.isMobile ? '8px' : '10px';
      controlUITraffic.style.marginBottom = "5px";
      this.buttonMapType_2.appendChild(controlUITraffic);
      let controlTextTraffic = document.createElement('div');
      controlTextTraffic.style.color = "#fff";
      controlTextTraffic.style.fontFamily = 'Roboto,Arial,sans-serif';
      controlTextTraffic.style.fontSize = MainMapService.isMobile ? '8px' : '10px';
      controlTextTraffic.style.lineHeight = '38px';
      controlTextTraffic.style.paddingLeft = '5px';
      controlTextTraffic.style.paddingRight = '5px';
      controlTextTraffic.style.textOverflow = 'ellipsis';
      controlTextTraffic.style.overflow = 'hidden';
      controlTextTraffic.style.whiteSpace = 'nowrap';
      controlTextTraffic.style.marginTop = MainMapService.isMobile ? '20px' : '40px';
      controlTextTraffic.innerHTML = MainMapService.infotrafficLabel;
      this.buttonMapType_2.addEventListener('click', () => {
        if(MainMapService.currentInfotraffic){
          MainMapService.currentInfotraffic = false;
          this.googleMaps.disableInfoTraffic();
          controlUITraffic.style.borderColor = "#fff";
        }else{
          MainMapService.currentInfotraffic = true;
          this.googleMaps.enableInfoTraffic();
          controlUITraffic.style.borderColor = "#32aadf";
        }
      });
      controlUITraffic.appendChild(controlTextTraffic);
    }
    this.map.controls[GoogleMapsService.google.maps.ControlPosition.RIGHT_BOTTOM].push(this.buttonMapType_1);
    this.map.controls[GoogleMapsService.google.maps.ControlPosition.RIGHT_BOTTOM].push(this.buttonMapType_2);

  }

  static clearService(){
    MainMapService.initCount = -1;
    MainMapService.currentZoom = undefined;
    MainMapService.currentCenter = undefined;
    MainMapService.currentInfotraffic = undefined;
    MainMapService.currentMapType = undefined;
  }

  requestResize(consumed?: boolean){
    this.needResize = !consumed;
  }

  isToResize(): boolean{
    return this.needResize;
  }

  // Dice se la mappa è già visibile
  isCurrentMap(){
    return this.googleMaps.currentMap === this.MAP_NAME;
  }

  private closePopupUI() {
    if (this.infoWindow) this.infoWindow.close();
    if (this.infoWindowGsmMarker) this.infoWindowGsmMarker.close();
    if(this.expandedParticipantId){
      if (this.circle) this.googleMaps.removeCircle(this.circle, this.MAP_NAME);
      if (this.selectedMarker) this.googleMaps.removeMarker(this.selectedMarker, this.MAP_NAME);
    }
  }

  closeInfoWindow(){
  console.log('close infowindow')
   this.closePopupUI();

    /* Rimuovo anche il marker blu di "posizione selezionata" (da ricerca indirizzo
     * o click su mappa): chiudendo il popup "puoi creare un P.O.I." non deve restare. */
    this.removeSelectMarker();

    if (this.expandedParticipantId || this.expandedPoiId) {
      this.restoreMapState();
    }
  }

  /** Rimuove il marker blu temporaneo di posizione selezionata, se presente. */
  removeSelectMarker(){
    if(this.selectedMarker){
      this.googleMaps.removeMarker(this.selectedMarker, this.MAP_NAME);
      this.selectedMarker.map = null;
      this.selectedMarker = undefined;
    }
  }

  /* POI attivo nella modalità "visualizza veicoli in area" (null = modalità non
   * attiva). Serve a ricalcolare la visibilità dei veicoli che si muovono. */
  private vehiclesInAreaPoi: Poi = null;

  /**
   * Modalità "visualizza veicoli in area": mostra in mappa solo i veicoli dentro
   * l'area del POI, nascondendo quelli fuori. Tutti i marker POI vengono nascosti
   * (resta visibile solo il contorno dell'area del POI attivo). Disegna l'area del
   * POI attivo e centra/fitta la mappa su di essa.
   */
  setVehiclesInAreaMode(poi: Poi, skipFit?: boolean){
    if(!poi || !this.data || !this.data.selOrganization) return;
    this.vehiclesInAreaPoi = poi;

    // Veicoli: mostro solo quelli dentro l'area (e non nascosti dall'utente),
    // gli altri vengono nascosti dalla mappa.
    for(const marker of this.participantMarkers){
      const participant = this.data.selOrganization.participants.find(p => p._id === marker.id);
      let inside = false;
      if(participant && participant.virtualPosition
         && participant.virtualPosition.latitude != null
         && participant.virtualPosition.longitude != null){
        inside = poi.containsPoint({
          lat: participant.virtualPosition.latitude,
          lng: participant.virtualPosition.longitude
        });
      }
      if(inside && participant && !participant.hideOnMap){
        this.googleMaps.showMarker(marker, this.MAP_NAME);
        if(marker.content) marker.content.style.opacity = '1';
      } else {
        this.googleMaps.hideMarker(marker, this.MAP_NAME);
      }
    }

    // POI: li nascondo tutti dalla mappa (resta visibile solo il contorno
    // dell'area del POI attivo, disegnato sotto).
    for(const marker of this.poiMarkers){
      this.googleMaps.hideMarker(marker, this.MAP_NAME);
    }

    // Disegno l'area del POI attivo (cerchio/poligono).
    this.drawCirclePoi(poi);
    // Centro/fitto sull'area, a meno che non sia una semplice ri-applicazione
    // (es. chiusura del dettaglio mentre la modalità è già attiva: nessun re-fit).
    if(!skipFit){
      this.fitOnPoiArea(poi);
      if(!poi.isPolygon() && !this.circle && poi.latitude != null && poi.longitude != null){
        this.setCenter(poi.latitude, poi.longitude);
      }
    }
  }

  /** Esce dalla modalità "visualizza veicoli in area": ripristina la visibilità
   *  di veicoli e POI (rispetto hideOnMap) e rimuove l'area disegnata del POI attivo. */
  clearVehiclesInAreaMode(){
    this.vehiclesInAreaPoi = null;
    // Ripristino la visibilità dei veicoli nascosti durante la modalità (rispetto hideOnMap).
    for(const marker of this.participantMarkers){
      if(marker.content) marker.content.style.opacity = '1';
      const participant = (this.data && this.data.selOrganization)
        ? this.data.selOrganization.participants.find(p => p._id === marker.id) : null;
      if(participant && participant.hideOnMap){
        this.googleMaps.hideMarker(marker, this.MAP_NAME);
      } else {
        this.googleMaps.showMarker(marker, this.MAP_NAME);
      }
    }
    // Ripristino la visibilità dei POI nascosti durante la modalità (rispetto hideOnMap).
    for(const marker of this.poiMarkers){
      if(marker.content) marker.content.style.opacity = '1';
      const poi = (this.data && this.data.pois) ? this.data.pois.find(p => p._id === marker.id) : null;
      if(poi && poi.hideOnMap){
        this.googleMaps.hideMarker(marker, this.MAP_NAME);
      } else {
        this.googleMaps.showMarker(marker, this.MAP_NAME);
      }
    }
    this.removeCirclePoi();
  }

  getMarkersAtClick(event) {
    const clickX = event.clientX;
    const clickY = event.clientY;
    const overlappingMarkers = [];

    this.participantMarkers.forEach(marker => {
      const rect = marker.content.getBoundingClientRect();

      const isClickInside =
        clickX >= rect.left &&
        clickX <= rect.right &&
        clickY >= rect.top &&
        clickY <= rect.bottom;

      if (isClickInside) {
        overlappingMarkers.push(marker);
      }
    });

    this.poiMarkers.forEach(marker => {
      const rect = marker.content.getBoundingClientRect();

      const isClickInside =
        clickX >= rect.left &&
        clickX <= rect.right &&
        clickY >= rect.top &&
        clickY <= rect.bottom;

      if (isClickInside) {
        overlappingMarkers.push(marker);
      }
    });

    return overlappingMarkers;
  }


  drawSelectMarker(lat: number, lng: number){
    if(this.selectedMarker?.map) this.selectedMarker.map = null;
    this.selectedMarker = new GoogleMapsService.google.maps.marker.AdvancedMarkerElement({
      zIndex: 10000,
      map: this.map,
      position: { lat, lng },
      content: this.googleMaps.createSelectedMarker()
    });
    this.selectedMarker.id = 'seleceted-marker';
    this.googleMaps.addMarker(this.selectedMarker, this.MAP_NAME);
    this.onSelectMarker.next({type: 'selected-marker', id: this.selectedMarker.id, position: {lat: lat, lng:lng}});
    if (!this.cambioDaCodice) this.pauseAutoZoomByUser();
    this.infoWindow.open(this.map, this.selectedMarker);
    this.selectedMarker.addListener("click", () => {
      this.onSelectMarker.next({type: 'selected-marker', id: this.selectedMarker.id, position: {lat: lat, lng:lng}});
      if (!this.cambioDaCodice) this.pauseAutoZoomByUser();
      this.infoWindow.open(this.map, this.selectedMarker);
    });
  }



  drawParticipantMarkers(participants: Partecipant[]){
    MainMapService.guideMarkerAssigned = false;
    this.participantMarkers = [];
    for(let i=0; i<participants.length; i++){
      this.drawSingleParticipantMarker(participants[i]);
    }
  }

  drawSingleParticipantMarker(participant: Partecipant){
    // Determino le coordinate del marker:
    // - default: uso virtualPosition (GPS)
    // - fallback SOLO per queclink: se il GPS e' 0,0 o mancante ma abbiamo posizione GSM
    //   (position_cell_id) la uso. Cosi' il marker viene comunque creato + reso cliccabile,
    //   altrimenti expandParticipant non lo trovava in participantMarkers e il dettaglio
    //   non si apriva. La logica resta invariata per tutti gli altri tipi di tracker.
    let coord: any = null;
    if(participant.virtualPosition && participant.virtualPosition.latitude && participant.virtualPosition.longitude){
      coord = {
        lat: participant.virtualPosition.latitude,
        lng: participant.virtualPosition.longitude
      };
    }else if(
      participant.isQueclink && participant.isQueclink() &&
      participant.position_cell_id && participant.position_cell_id.latitude && participant.position_cell_id.longitude
    ){
      coord = {
        lat: participant.position_cell_id.latitude,
        lng: participant.position_cell_id.longitude
      };
    }
    if(coord){

      const content = MainMapService.createParticipantMarker();
      if(!MainMapService.guideMarkerAssigned){
        content.setAttribute('data-testid', 'step-guide-map-marker');
        MainMapService.guideMarkerAssigned = true;
      }
      content.setAttribute('data-marker-id', participant._id);

      let marker: any = new GoogleMapsService.google.maps.marker.AdvancedMarkerElement({
        zIndex: 10,
        position: coord,
        content: content,
        map: this.map
      });
      marker.id = participant._id;
      marker.type = 'participant';

      this.participantMarkers.push(marker);

      /* addMarker PRIMA di updateParticipantMarker: update chiude applicando la
       * visibilita' (hideOnMap) via googleMaps.hideMarker, che agisce solo sui
       * marker gia' registrati. Con l'ordine inverso il nascondimento cadeva nel
       * vuoto e addMarker riagganciava il marker alla mappa: i veicoli nascosti
       * tornavano visibili a ogni redraw senza ripristino (es. ionViewDidEnter). */
      this.googleMaps.addMarker(marker, this.MAP_NAME);
      this.updateParticipantMarker(participant);

      /* Se la modalità "visualizza veicoli in area" è attiva, nascondo i veicoli
       * fuori area anche dopo un redraw (drawParticipantMarkers/initMap). Va fatto
       * dopo addMarker: prima il marker non è ancora registrato in googleMaps. */
      if(this.vehiclesInAreaPoi){
        const inside = !!(participant.virtualPosition
          && participant.virtualPosition.latitude != null
          && participant.virtualPosition.longitude != null
          && this.vehiclesInAreaPoi.containsPoint({lat: participant.virtualPosition.latitude, lng: participant.virtualPosition.longitude}));
        if(!(inside && !participant.hideOnMap)){
          this.googleMaps.hideMarker(marker, this.MAP_NAME);
        }
      }

      marker.addEventListener('click', (e: any) => {
        e.stopPropagation();
        this.closeInfoWindow();

        let click_in_spider: boolean;
        if(this.googleMaps.markers_in_spider?.find(elem => elem.id === participant._id)){
          click_in_spider = true;
        }
        this.googleMaps.unspiderfyMarkers(MainMapService.popupVisible);

        if(click_in_spider){
          marker.zIndex = 1000;
          this.onSelectMarker.next({type: 'participant', id: marker.id});
          return;
        }else{
          const clickX = e.clientX;
          const clickY = e.clientY;

          this.googleMaps.markers_in_spider = this.getMarkersAtClick(e);
          if (this.googleMaps.markers_in_spider.length > 1) {
            // include anche il marker cliccato
            if(this.googleMaps.markers_in_spider.length > 12) {
              this.googleMaps.spiderfyMoltiMarkers(clickX, clickY, this.googleMaps.markers_in_spider);
            }else{
              this.googleMaps.spiderfyMarkers(clickX, clickY, this.googleMaps.markers_in_spider);
            }
          } else {
            this.onSelectMarker.next({type: 'participant', id: marker.id});
          }
        }

        if (!this.cambioDaCodice){
          console.log('Quaas')
          this.pauseAutoZoomByUser();
        }
      });
    }
  }

  static createParticipantMarker() {
    const markerContent = document.createElement("div");
    markerContent.innerHTML = `
<div class="mappa_custom-marker">
  <div class="mappa_marker-label"></div>
  <div class="mappa_marker-scalable">
    <div class="mappa_marker">
      <div class="mappa_label_number"></div>
      <div class="mappa_internal_img"></div>
      <div class="mappa_arrow-icon">
        <svg class="mappa_arrow-svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.16496 19.5025L10.5275 2.99281C11.1178 1.66906 12.8822 1.66906 13.4725 2.99281L20.835 19.5025C21.5021 20.9984 20.0209 22.5499 18.6331 21.809L12.7294 18.657C12.2702 18.4118 11.7298 18.4118 11.2706 18.657L5.36689 21.809C3.97914 22.5499 2.49789 20.9984 3.16496 19.5025Z" fill="#aaa"/>
        </svg>
      </div>
      <div class="mappa_etichetta_number"></div>
      <div class="mappa_din1_state"></div>
      <div class="mappa_v-marker-border"></div>
      <div class="mappa_v-marker"></div>
    </div>
  </div>
</div>
`;
    return markerContent.firstElementChild;
  }

  updateParticipantMarker(participant: Partecipant){
    let marker: any = this.participantMarkers.find((elem: any) => {
      return elem.id === participant._id;
    });
    if(marker){ // modifico il marker esistente
      // Aggiorno posizione
      marker.position = {lat: participant.virtualPosition.latitude, lng: participant.virtualPosition.longitude};

      if(participant.isQueclink() && participant.position_cell_id && participant.position_cell_id.latitude && participant.position_cell_id.accuracy){
        marker.position = {lat: participant.position_cell_id.latitude, lng: participant.position_cell_id.longitude};
      }

      // setto immagine se necessario
      const element: any = marker.content.querySelector('.mappa_internal_img');
      if(participant.image){
        element.style.backgroundImage = `url(${participant.image})`;
      }else{
        element.style.backgroundImage = 'none';
      }

      // setto label number
      const etichetta: any = marker.content.querySelector('.mappa_etichetta_number');
      let label_elem = marker.content.querySelector(".mappa_label_number");
      etichetta.textContent = `${participant.label_number || ''}`;
      label_elem.textContent = `${participant.label_number || ''} `;
      if(!MainMapService.labelVisible || !participant.label_number){
        label_elem.style.display = 'none';
        etichetta.style.display = 'none';
      }else{
        label_elem.style.display = 'block';
        if(participant.image){
          etichetta.style.display = 'block';
        }else{
          etichetta.style.display = 'none';
        }
      }

      const angle: any = marker.content.querySelector(".mappa_arrow-svg");
      angle.style.transform = `rotate(${participant.virtualPosition.angle || 0}deg)`;
      if(participant.virtualPosition.tripStatus){
        marker.content.querySelector(".mappa_marker").style.backgroundColor = '#0ca000';
        marker.content.querySelector(".mappa_v-marker").style.borderTopColor = '#0ca000';
      }else{
        marker.content.querySelector(".mappa_marker").style.backgroundColor = '#fa2200';
        marker.content.querySelector(".mappa_v-marker").style.borderTopColor = '#fa2200';
      }
      const din1: any = participant.getIn1State();
      const din1_elem: any = marker.content.querySelector(".mappa_din1_state");
      if(din1 !== undefined){
        din1_elem.style.display = 'unset';
        din1_elem.style.backgroundColor = din1 ? '#fad401' : '#8f8d8d';
      }else{
        din1_elem.style.display = 'none';
      }

      let label_string: any = marker.content.querySelector(".mappa_marker-label");
      label_string.textContent = participant.name || participant.imei;
      if(MainMapService.popupVisible){
        label_string.style.display = 'unset';
      }else{
        label_string.style.display = 'none';
      }

      /* Modalità "visualizza veicoli in area": ha PRIORITÀ sulla logica
       * expand/normale sotto. Mostro solo i veicoli dentro l'area (e non nascosti
       * dall'utente), nascondo gli altri, poi esco. Senza questo return, il ramo
       * "modalità normale" ri-mostrerebbe i veicoli fuori area a ogni update. */
      if(this.vehiclesInAreaPoi && marker.position){
        const inside = this.vehiclesInAreaPoi.containsPoint({lat: marker.position.lat, lng: marker.position.lng});
        if(inside && !participant.hideOnMap){
          if(!marker.map) this.googleMaps.showMarker(marker, this.MAP_NAME);
          marker.content.style.opacity = '1';
        } else {
          this.googleMaps.hideMarker(marker, this.MAP_NAME);
        }
        return;
      }

      if (this.expandedPoiId) {
        if (this.showContextDuringExpand) {
          // Mostra solo se l'utente non lo ha nascosto coi filtri
          if (!participant.hideOnMap) {
            if(!marker.map){
              this.googleMaps.showMarker(marker, this.MAP_NAME);
            }
          } else {
            this.googleMaps.hideMarker(marker, this.MAP_NAME);
          }
        } else {
          // NASCONDI TASSATIVAMENTE TUTTI I VEICOLI
          this.googleMaps.hideMarker(marker, this.MAP_NAME);
        }
        return; // ESCI, abbiamo finito con questo veicolo
      }


      if (this.expandedParticipantId) {
        // SIAMO IN MODALITÀ EXPAND
        if (this.expandedParticipantId === participant._id) {
          // È il veicolo selezionato: Aggiorna e mantieni visibile
          marker.zIndex = 1000;
          if (!marker.map) marker.map = this.map;

          // Pan automatico se si muove
          const hasCellData = participant.position_cell_id && participant.position_cell_id.latitude && participant.position_cell_id.accuracy;

          if (hasCellData && !participant.isGPSOk()) {
            // CASO A: Abbiamo dati cella -> Disegna cerchio e fai FIT BOUNDS (zoom su entrambi)
            this.drawCellIdCircle(participant);
          } else {
            // CASO B: Solo GPS -> Fai PAN TO classico sul veicolo e rimuovi eventuali cerchi vecchi
            this.map.panTo({
              lat: participant.virtualPosition.latitude,
              lng: participant.virtualPosition.longitude
            });
            this.removeCellIdCircle();
          }

          // Aggiorna il cerchio di accuratezza
          this.drawCellIdCircle(participant);
        } else {

          if (this.showContextDuringExpand) {
            // Se "Mostra Tutti" è attivo, rispetto hideOnMap
            if (!participant.hideOnMap) {
              if(!marker.map) {
                this.googleMaps.showMarker(marker, this.MAP_NAME);
              }
            } else {
              this.googleMaps.hideMarker(marker, this.MAP_NAME);
            }
          } else {
            // Se "Focus" è attivo, nascondo
            this.googleMaps.hideMarker(marker, this.MAP_NAME);
          }
        }
      } else {
        // MODALITÀ NORMALE (Mostra tutti, rispetta hideOnMap)
        if (!participant.hideOnMap) {
          if(!marker.map){
            this.googleMaps.showMarker(marker, this.MAP_NAME);
          }
        } else {
          this.googleMaps.hideMarker(marker, this.MAP_NAME);
        }
      }

    }else if(participant.isInFleet()){ // devo aggiungere il marker perchè è nuovo solo se è in flotta
      this.drawSingleParticipantMarker(participant);
    }

    if(MainMapService.autoFollow && !this.autoZoomPausedByUser){
      const now = Date.now();
      if (now - this.lastAutoZoomTime > 10000) { // 10 secondi
        this.resizeMarkerParticipant();
        this.lastAutoZoomTime = now;
      }
    }
  }

  removeParticipantMarker(id: string){
    for(let i=0; i<this.participantMarkers.length; i++){
      if(this.participantMarkers[i].id === id){
        this.googleMaps.removeMarker(this.participantMarkers[i], this.MAP_NAME);
        this.participantMarkers.splice(i, 1);
        return;
      }
    }
  }

  toggleVisibilityLabel(visible: boolean){
    MainMapService.labelVisible = visible;
    for(let marker of this.participantMarkers){
      this.showLabelMarker(marker);
    }
    for(let marker of this.poiMarkers){
      this.showLabelMarker(marker);
    }
  }

  private showLabelMarker(marker: any){
    const etichetta: any = marker.content.querySelector('.mappa_etichetta_number');
    let label_elem = marker.content.querySelector(".mappa_label_number");
    if(!MainMapService.labelVisible){
      label_elem.style.display = 'none';
      etichetta.style.display = 'none';
    }else{
      label_elem.style.display = 'block';
      let div_image = marker.content.querySelector(".mappa_internal_img");
      if(div_image.style.backgroundImage !== 'none'){
        etichetta.style.display = 'block';
      }else{
        etichetta.style.display = 'none';
      }
    }
  }

  toggleVisibilityPopup(visible: boolean){
    MainMapService.popupVisible = visible;
    for(let marker of this.participantMarkers){
      this.showPopupParticipantMarker(marker);
    }
  }

  private showPopupParticipantMarker(marker: any){
    const label_elem: any = marker.content.querySelector(".mappa_marker-label");
    if(MainMapService.popupVisible){
      label_elem.style.display = 'unset';
    }else{
      label_elem.style.display = 'none';
    }
  }

  toggleVisibilityParticipant(participant: Partecipant){
    if(this.infoWindow) this.infoWindow.close();
    for(let marker of this.participantMarkers){
      if(marker.id === participant._id){
        if(participant.hideOnMap){
          if (!this.expandedParticipantId || this.expandedParticipantId === participant._id){
            if(marker.map){
              marker.map = null;
            }
          }
        }else{
          if (!this.expandedParticipantId || this.expandedParticipantId === participant._id) {
            if(!marker.map){
              marker.map = this.map;
            }
          }
        }
        break;
      }
    }
  }

  selectParticipant(id: string){
    for(let marker of this.participantMarkers){
      if(marker.id === id){
        this.expandParticipant(marker.id)

        let position: any = marker.position;
        this.setCenter(position.lat, position.lng); //Imposta il centro delle mappa senza animazioni

        // if (!this.cambioDaCodice) this.pauseAutoZoomByUser(); //Non lo faccio, viene fatto da expandParticipant

        this.onSelectMarker.next({type: 'participant', id: marker.id});
        const participant = this.data.selOrganization.getParticipant(marker.id);


        if(participant.isQueclink()){
          this.getTracker(participant.imei).then((tracker: any) => {
            // Il .then puo' arrivare fuori dalla Angular zone: rientriamo esplicitamente
            // e notifichiamo ViewService cosi' le page che sottoscrivono updateView$ fanno
            // markForCheck e la sezione "Orari di trasmissione" appare subito.
            this.zone.run(() => {
              participant.$tracker = new TrackerGps(tracker, {getProgramming: this.data.getProgrammingVersion});
              ViewService.updateView.next(undefined);
            });
          })

          if(!participant.isGPSOk()){
            this.drawCellIdCircle(participant);
          }

        }
        return;
      }
    }
  }


  async getTracker(imei: string){
    return DataService.api.getTrackerGpsFromImei(imei, this.data.selOrganization.me._id)
  }


  drawPoiMarkers(pois: Poi[]){
    this.poiMarkers = [];
    for(let i=0; i<pois.length; i++){
      this.drawSinglePoiMarker(pois[i]);
    }
  }

  drawSinglePoiMarker(poi: Poi){
    if(poi.position && poi.position.coordinates && poi.position.coordinates.length === 2){
      const coord: any = {
        lat: poi.position.coordinates[1],
        lng: poi.position.coordinates[0]
      };
      let marker: any = new GoogleMapsService.google.maps.marker.AdvancedMarkerElement({
        zIndex: 1,
        position: coord,
        content: GoogleMapsService.createPoiMarker(poi),
        map: this.map
      });
      marker.id = poi._id;
      marker.type = 'poi';
      /* Riferimento al poi sul marker: utile in expandPoi per fittare la mappa
       * sull'area (cerchio/polygon) senza dover passare per DataService. */
      marker._poi = poi;
      /* Se la modalita' "sempre visibile" e' attiva, disegno l'area subito. */
      if(MainMapService.alwaysShowPoiAreas && !poi.hideOnMap){
        this.drawPoiArea(poi);
      }

      this.poiMarkers.push(marker);

      this.updatePoiMarker(poi);
      this.googleMaps.addMarker(marker, this.MAP_NAME);

      /* Se la modalità "visualizza veicoli in area" è attiva, i POI restano nascosti
       * anche dopo un redraw (drawPoiMarkers/initMap) o la creazione di un nuovo POI.
       * Stesso discorso per i POI nascosti dall'utente con la stellina: updatePoiMarker
       * non tocca la visibilita', quindi senza questo controllo un redraw senza
       * ripristino (es. ionViewDidEnter) li rimetteva in mappa. */
      if(this.vehiclesInAreaPoi || poi.hideOnMap){
        this.googleMaps.hideMarker(marker, this.MAP_NAME);
      }

      marker.addListener('click', (e: any) => {
        e = e.domEvent;
        e.stopPropagation();
        this.closeInfoWindow();
        if (!this.cambioDaCodice) this.pauseAutoZoomByUser();
        let click_in_spider: boolean;
        if(this.googleMaps.markers_in_spider?.find(elem => elem.id === poi._id)){
          click_in_spider = true;
        }
        this.googleMaps.unspiderfyMarkers(MainMapService.popupVisible);
        if(click_in_spider){
          marker.zIndex = 1000;
          this.onSelectMarker.next({type: 'poi', id: marker.id});
          // if(!MainMapService.isMobile) this.infoWindow.open(this.map, marker);
          return;
        }else{
          const clickX = e.clientX;
          const clickY = e.clientY;

          this.googleMaps.markers_in_spider = this.getMarkersAtClick(e);
          if (this.googleMaps.markers_in_spider.length > 1) {
            // include anche il marker cliccato
            if(this.googleMaps.markers_in_spider.length > 12) {
              this.googleMaps.spiderfyMoltiMarkers(clickX, clickY, this.googleMaps.markers_in_spider);
            }else{
              this.googleMaps.spiderfyMarkers(clickX, clickY, this.googleMaps.markers_in_spider);
            }
          } else {
            this.onSelectMarker.next({type: 'poi', id: marker.id});
            // if(!MainMapService.isMobile) this.infoWindow.open(this.map, marker);
          }
        }
      });
    }
  }

  /** Disegna l'area del POI selezionato sulla mappa. Per i POI 'circle' un cerchio
   *  attorno al marker, per i POI 'polygon' un Polygon dai vertici GeoJSON. */
  drawCirclePoi(poi: Poi){
    this.removeCirclePoi();
    this.selectedAreaPoiId = poi._id;
    /* Colore area/bordo dal POI (fallback al default blu storico se non settato). */
    const color = poi.color || '#2e97f2';
    /* POI poligonale: disegno il Polygon dai vertici GeoJSON (non dipende dal marker). */
    if(poi.isPolygon && poi.isPolygon()){
      const ring = poi.area.coordinates[0]; // [[lng,lat], ...] gia' chiuso
      const path = ring.map(([lng, lat]: number[]) => ({ lat, lng }));
      this.poiPolygon = new GoogleMapsService.google.maps.Polygon({
        paths: path,
        strokeColor: color,
        strokeWeight: 2,
        strokeOpacity: 0.95,
        fillColor: color,
        fillOpacity: 0.15,
        clickable: false,
        id: 'poiPolygon'
      });
      /* Registro nel googleMaps service cosi' clearMap() lo pulisce al cambio
       * contesto (es. apertura del modal di modifica POI). */
      this.googleMaps.addPolygon(this.poiPolygon, this.MAP_NAME);
      return;
    }
    /* POI cerchio (default). */
    for(let marker of this.poiMarkers){
      if(marker.id === poi._id){
        this.circle = new GoogleMapsService.google.maps.Circle({
          center: marker.position,
          radius: poi.radius,
          strokeColor: color,
          strokeWeight: 2,
          fillColor: color,
          fillOpacity: 0.15,
          id: 'circle'
        });
        this.googleMaps.addCircle(this.circle, this.MAP_NAME);
        return;
      }
    }
  }

  updatePoiMarker(poi: Poi){
    let marker: any = this.poiMarkers.find((elem: any) => {
      return elem.id === poi._id;
    });
    if(marker){ // Aggiorno il marker del poi
      marker.position = {lat: poi.latitude, lng: poi.longitude};
      /* Aggiorno anche il riferimento al poi (potrebbe aver cambiato area/radius
       * tipo dopo una modifica). */
      marker._poi = poi;
      /* Se la modalita' "sempre visibile" e' attiva, ridisegno l'area
       * (la geometria potrebbe essere cambiata). */
      if(MainMapService.alwaysShowPoiAreas){
        if(poi.hideOnMap){
          this.removePoiArea(poi._id);
        } else {
          this.drawPoiArea(poi);
        }
      }

      // setto immagine se necessario
      const element: any = marker.content.querySelector('.mappa_internal_img');
      const quadrato: any = marker.content.querySelector('.mappa_marker-quadrato');
      const vMarker: any = marker.content.querySelector('.mappa_v-marker');
      const label_number: any = marker.content.querySelector('.mappa_label_number');
      if(quadrato) quadrato.style.setProperty('background-color', poi.color || '', 'important');
      if(vMarker) vMarker.style.setProperty('border-top-color', poi.color || '', 'important');
      if(label_number) label_number.style.setProperty('color', poi.textColor || '', 'important');
      if(poi.image){
        element.style.backgroundImage = `url(${poi.image})`;
      }else{
        element.style.backgroundImage = 'none';
      }

      // setto il label number
      const etichetta: any = marker.content.querySelector('.mappa_etichetta_number');
      let label_elem = marker.content.querySelector(".mappa_label_number");
      etichetta.textContent = `${poi.label_number || ''}`;
      label_elem.textContent = `${poi.label_number || ''} `;
      if(!MainMapService.labelVisible || !poi.label_number){
        label_elem.style.display = 'none';
        etichetta.style.display = 'none';
      }else{
        label_elem.style.display = 'block';
        if(poi.image){
          etichetta.style.display = 'block';
        }else{
          etichetta.style.display = 'none';
        }
      }

    }else{ // Aggiungo un nuovo marker del poi
      this.drawSinglePoiMarker(poi);
    }
  }


  removePoiMarker(id: string){
    /* Se l'area (cerchio o poligono) era disegnata per questo POI, la ripulisco
     * anche lei: altrimenti dopo l'eliminazione del POI selezionato la sua area
     * rimarrebbe disegnata sulla mappa. */
    if(this.selectedAreaPoiId === id){
      this.removeCirclePoi();
    }
    /* Rimuovo anche l'area "sempre visibile" se presente. */
    this.removePoiArea(id);
    for(let i=0; i<this.poiMarkers.length; i++){
      if(this.poiMarkers[i].id === id){
        this.googleMaps.removeMarker(this.poiMarkers[i], this.MAP_NAME);
        this.poiMarkers.splice(i, 1);
        return;
      }
    }
  }

  removeCirclePoi(){
    if(this.circle) this.googleMaps.removeCircle(this.circle, this.MAP_NAME);
    this.circle = undefined;
    if(this.poiPolygon){
      this.googleMaps.removePolygon(this.poiPolygon, this.MAP_NAME);
      this.poiPolygon = undefined;
    }
    this.selectedAreaPoiId = null;
  }

  /* ────────────────────────────────────────────────────────────────────────
   *  Modalita' "Mostra sempre aree POI": disegna in mappa l'area (cerchio o
   *  polygon) di TUTTI i POI visibili, non solo quello selezionato.
   * ────────────────────────────────────────────────────────────────────── */

  /** Attiva o disattiva la modalita' "sempre visibile" per tutte le aree POI. */
  setAlwaysShowPoiAreas(enabled: boolean, pois: Poi[]){
    MainMapService.alwaysShowPoiAreas = enabled;
    if(enabled){
      this.drawAllPoiAreas(pois);
    } else {
      this.removeAllPoiAreas();
    }
  }

  /** Disegna le aree di tutti i POI passati (es. all'init mappa, o al toggle on). */
  drawAllPoiAreas(pois: Poi[]){
    if(!pois) return;
    for(const poi of pois){
      /* Salto quelli nascosti via stellina (hideOnMap) — coerenza con i marker. */
      if(poi.hideOnMap) continue;
      this.drawPoiArea(poi);
    }
  }

  /** Disegna l'area di un singolo POI (idempotente: rimuove eventuale area esistente
   *  e la ridisegna). Usato dal flag "sempre visibile" e dalle update/insert. */
  drawPoiArea(poi: Poi){
    if(!poi || !poi._id) return;
    this.removePoiArea(poi._id);
    /* Colore area/bordo dal POI (fallback al default). */
    const color = poi.color || '#2e97f2';
    let shape: any = null;
    if(poi.isPolygon && poi.isPolygon()){
      const ring = poi.area.coordinates[0];
      const path = ring.map(([lng, lat]: number[]) => ({ lat, lng }));
      shape = new GoogleMapsService.google.maps.Polygon({
        paths: path,
        strokeColor: color,
        strokeWeight: 2,
        strokeOpacity: 0.9,
        fillColor: color,
        fillOpacity: 0.12,
        clickable: false,
        id: 'poiArea_' + poi._id
      });
      this.googleMaps.addPolygon(shape, this.MAP_NAME);
    } else if(poi.position && poi.position.coordinates && poi.radius){
      shape = new GoogleMapsService.google.maps.Circle({
        center: {
          lat: poi.position.coordinates[1],
          lng: poi.position.coordinates[0]
        },
        radius: poi.radius,
        strokeColor: color,
        strokeWeight: 2,
        strokeOpacity: 0.9,
        fillColor: color,
        fillOpacity: 0.12,
        clickable: false,
        id: 'poiArea_' + poi._id
      });
      this.googleMaps.addCircle(shape, this.MAP_NAME);
    }
    if(shape) this.allPoiAreas[poi._id] = shape;
  }

  /** Rimuove l'area di un singolo POI (se presente). */
  removePoiArea(poiId: string){
    const shape = this.allPoiAreas[poiId];
    if(!shape) return;
    if(shape instanceof GoogleMapsService.google.maps.Polygon){
      this.googleMaps.removePolygon(shape, this.MAP_NAME);
    } else {
      this.googleMaps.removeCircle(shape, this.MAP_NAME);
    }
    delete this.allPoiAreas[poiId];
  }

  /** Rimuove tutte le aree "sempre visibili". */
  removeAllPoiAreas(){
    for(const id in this.allPoiAreas){
      this.removePoiArea(id);
    }
    this.allPoiAreas = {};
  }

  toggleVisibilityPoi(poi: Poi){
    if(this.infoWindow) this.infoWindow.close();
    for(let marker of this.poiMarkers){
      if(marker.id === poi._id){
        if(poi.hideOnMap){
          if(marker.map){
            this.googleMaps.removeMarker(marker, this.MAP_NAME);
          }
          /* In modalita' sempre-visibile l'area segue la visibilita' del marker. */
          if(MainMapService.alwaysShowPoiAreas){
            this.removePoiArea(poi._id);
          }
        }else{
          if(!marker.map){
            this.googleMaps.addMarker(marker, this.MAP_NAME);
          }
          if(MainMapService.alwaysShowPoiAreas){
            this.drawPoiArea(poi);
          }
        }
        return;
      }
    }
  }

  selectPoi(id: string){
    for(let marker of this.poiMarkers){
      if(marker.id === id){
        this.expandPoi(marker.id)

        /* Centro/zoom sull'area: a questo livello pero' non abbiamo il poi
         * completo (solo l'id/marker). Il page subscriber a onSelectMarker
         * chiama selectPoi(poi) e poi fitOnPoiArea(poi) col fit definitivo
         * sull'area. Qui mi fermo a un setCenter sul marker per dare un
         * primo centramento immediato (il fit lo finalizza la page). */
        let position: any = marker.position;
        this.setCenter(position.lat, position.lng);
        this.onSelectMarker.next({type: 'poi', id: marker.id});
        if (!this.cambioDaCodice) this.pauseAutoZoomByUser();
        // this.infoWindow.open(this.map, marker);
        return;
      }
    }
  }

  /** Fit della mappa sull'area del POI:
   *  - polygon: bounds calcolato dai vertici GeoJSON
   *  - circle: bounds calcolato dal Circle gia' disegnato (drawCirclePoi)
   *  Cap di zoom 17, padding 60px per non lasciarla flush al bordo. */
  fitOnPoiArea(poi: Poi){
    if(!this.map || !poi) return;
    let bounds: any = null;
    if(poi.isPolygon && poi.isPolygon()){
      const ring = poi.area.coordinates[0];
      bounds = new GoogleMapsService.google.maps.LatLngBounds();
      for(const [lng, lat] of ring){
        bounds.extend({ lat, lng });
      }
    } else if(this.circle){
      bounds = this.circle.getBounds();
    }
    if(!bounds || (bounds.isEmpty && bounds.isEmpty())) return;
    /* cambioDaCodice = true per dire al sistema di auto-follow che lo zoom
     * sta avvenendo programmaticamente (non e' un'azione utente). */
    this.cambioDaCodice = true;
    this.map.fitBounds(bounds, 60 /* px padding */);
    setTimeout(() => {
      if(this.map.getZoom() > 17){
        this.map.setZoom(17);
      }
      this.cambioDaCodice = false;
    }, 300);
  }

  enableAutoFollow(){
    MainMapService.autoFollow = true;
    this.resumeAutoFollow()
    this.resizeMarkerParticipant();
  }

  disableAutoFollow(){
    MainMapService.autoFollow = false;
    this.resumeAutoFollow();
  }

  resizeMarkerParticipant() {
    let bounds: any = new GoogleMapsService.google.maps.LatLngBounds();

    for (let i = 0; i < this.participantMarkers.length; i++) {
      if (this.participantMarkers[i].map) {
        bounds.extend(this.participantMarkers[i].position);
      }
    }

    for (let i = 0; i < this.poiMarkers.length; i++) {
      if (this.poiMarkers[i].map) {
        bounds.extend(this.poiMarkers[i].position);
      }
    }

    if (!bounds.isEmpty()) {
      this.cambioDaCodice = true;
      this.map.fitBounds(bounds, 50);

      setTimeout(() => {
        if (this.map.getZoom() > 16) {
          this.map.setZoom(16);
        }
        this.cambioDaCodice = false;
      }, 500);
    }
  }

  resumeAutoFollow(){
    this.autoZoomPausedByUser = false;
    this.onUpdateAutoFollow.next({pause: false, status: MainMapService.autoFollow});
    //
    this.cambioDaCodice = true;
    this.resizeMarkerParticipant();
    this.closeInfoWindow()
    setTimeout(() => {
      this.cambioDaCodice = false;
    }, 200);
  }

  setCambioDaCodice(value: boolean){
    this.cambioDaCodice = value;
  }

  async expandPoi(id: string){
    this.expandedPoiId = id;
    this.showContextDuringExpand = false;
    if(!this.preExpandZoom) this.preExpandZoom = this.map.getZoom();
    this.pauseAutoZoomByUser();

    this.onExpandStateChange.next({ expanded: true, poiId: id });

    this.closePopupUI();

    await Utility.wait(500);

    // 3. Fit della mappa sull'area del POI (cerchio o polygon) invece di un
    //    semplice pan+zoom sul marker centrale: l'utente vede l'area completa.
    const selectedMarker = this.poiMarkers.find(m => m.id === id);
    if (selectedMarker) {
      const poi: Poi = selectedMarker._poi;
      if(poi){
        this.fitOnPoiArea(poi);
      }else{
        // Fallback per sicurezza (marker senza _poi): pan+zoom sul centro.
        this.map.panTo(selectedMarker.position);
        this.smoothZoom(this.map, 17, this.map.getZoom());
      }
    }

    this.refreshExpandVisibility();
  }

  /** Variante di expandParticipant per veicoli SENZA marker sulla mappa
   * (es. tracker GPS attivato ma senza posizione GPS ricevuta).
   * Non fa zoom/pan/draw — emette solo lo stato di expand per aprire il
   * pannello dettaglio lateralmente. */
  expandParticipantNoMarker(id: string){
    this.expandedParticipantId = id;
    this.showContextDuringExpand = false;
    this.pauseAutoZoomByUser();
    this.onExpandStateChange.next({ expanded: true, carId: id });
    this.closePopupUI();
  }

  async expandParticipant(id: string) {
    this.expandedParticipantId = id;
    this.showContextDuringExpand = false;
    if(!this.preExpandZoom) this.preExpandZoom = this.map.getZoom();
    this.pauseAutoZoomByUser();

    // 1. Notifica la UI (Sidebar)
    this.onExpandStateChange.next({ expanded: true, carId: id });

    // 2. Chiudi la grafica del popup vecchio
    this.closePopupUI();

    await Utility.wait(500);

    // 3. Zoom e Pan verso il veicolo
    const selectedMarker = this.participantMarkers.find(m => m.id === id);
    const participant = this.data.selOrganization.getParticipant(selectedMarker.id);
    // Controlla se abbiamo dati della cella
    const hasCellData = participant &&
      participant.position_cell_id &&
      participant.position_cell_id.latitude &&
      participant.position_cell_id.accuracy;

    if (selectedMarker && hasCellData && !participant.isGPSOk()) {
      // Caso Posizione senza gps con cell id, disegno un cerchio
      this.drawCellIdCircle(participant);
    } else {
      // Caso solo GPS -> Zoom e Pan classici sul marker
      this.map.panTo(selectedMarker.position);
      this.smoothZoom(this.map, 17, this.map.getZoom());
      this.removeCellIdCircle(); // Pulizia sicurezza
    }

    this.refreshExpandVisibility();
  }

  private refreshExpandVisibility() {
    // 1. GESTIONE PARTECIPANTI (Veicoli)
    this.participantMarkers.forEach(marker => {

      // IL VEICOLO SELEZIONATO (Sempre visibile)
      if (marker.id === this.expandedParticipantId) {
        if (!this.activeAccuracyCircle) {
          if (!marker.map) this.googleMaps.showMarker(marker, this.MAP_NAME);
        }
        marker.zIndex = 1000;
        return;
      }

      marker.zIndex = null;

      if (this.showContextDuringExpand) {
        // MOSTRA TUTTI (Se non nascosti dall'utente)
        let participant: Partecipant | undefined;
        if (this.data && this.data.selOrganization) {
          participant = this.data.selOrganization.participants.find(p => p._id === marker.id);
        }
        if (participant && !participant.hideOnMap) {
          this.googleMaps.showMarker(marker, this.MAP_NAME);
        } else {
          this.googleMaps.hideMarker(marker, this.MAP_NAME);
        }
      } else {
        this.googleMaps.hideMarker(marker, this.MAP_NAME);
      }
    });

    // 2. GESTIONE POI
    this.poiMarkers.forEach(marker => {


      if (marker.id === this.expandedPoiId) {
        if (!this.activeAccuracyCircle) {
          if (!marker.map) this.googleMaps.showMarker(marker, this.MAP_NAME);
        }
        marker.zIndex = 1000;
        return;
      }

      marker.zIndex = null;

      if (this.showContextDuringExpand) {
        // MOSTRA POI (Se non nascosti dall'utente)
        let poi: Poi | undefined;
        if (this.data && this.data.pois) {
          poi = this.data.pois.find(p => p._id === marker.id);
        }

        if (poi && !poi.hideOnMap) {
          this.googleMaps.showMarker(marker, this.MAP_NAME);
        } else {
          this.googleMaps.hideMarker(marker, this.MAP_NAME);
        }
      } else {
        // NASCONDI POI (Focus mode)
        this.googleMaps.hideMarker(marker, this.MAP_NAME);
      }
    });
  }

  toggleContextVisibility() {
    this.showContextDuringExpand = !this.showContextDuringExpand;
    this.refreshExpandVisibility();
  }

  restoreMapState() {
    this.onExpandStateChange.next({ expanded: false});

    // Zoom out (opzionale, se vuoi mantenere lo zoom attuale rimuovi questo if)
    if (this.preExpandZoom) {
      this.map.setZoom(this.preExpandZoom)
    }
    this.preExpandZoom = undefined

    // RIPRISTINA VISIBILITÀ DI TUTTI
    this.participantMarkers.forEach(marker => {

      let participant: Partecipant | undefined;
      if (this.data && this.data.selOrganization) {
        participant = this.data.selOrganization.participants.find(p => p._id === marker.id);
      }
      if (participant && !participant.hideOnMap) {
        this.googleMaps.showMarker(marker, this.MAP_NAME);
        marker.zIndex = null;
        marker.content.style.opacity = '1';
      }

    });

    // Ripristina POI
    this.poiMarkers.forEach(marker => {
      let poi = this.data.pois.find(p => p._id === marker.id);
      if (poi && !poi.hideOnMap) {
        this.googleMaps.showMarker(marker, this.MAP_NAME);
      } else {
        this.googleMaps.hideMarker(marker, this.MAP_NAME);
      }
    });

    if(this.expandedPoiId){
      this.removeCirclePoi();
    }

    this.expandedParticipantId = null;
    this.expandedPoiId = null;

    this.preExpandZoom = null;
    this.removeCellIdCircle();


  }

  private smoothZoom(map: any, targetZoom: number, currentZoom: number) {
    if (currentZoom === targetZoom) return;

    const step = targetZoom > currentZoom ? 1 : -1;

    const zoomStep = () => {
      const nextZoom = map.getZoom() + step;

      if ((step > 0 && nextZoom > targetZoom) || (step < 0 && nextZoom < targetZoom)) {
        return;
      }

      map.setZoom(nextZoom);

      if (nextZoom !== targetZoom) {
        setTimeout(zoomStep, 80);
      }
    }

    zoomStep();
  }

  drawCellIdCircle(participant: Partecipant) {
    // Controllo se il partecipante ha i dati della cella geolocalizzata
    if (participant.position_cell_id && participant.position_cell_id.latitude && participant.position_cell_id.accuracy) {

      //Tolgo il marker della posizoine
      let marker: any = this.participantMarkers.find((elem: any) => {
        return elem.id === participant._id;
      });

      if(marker){
        this.googleMaps.hideMarker(marker, this.MAP_NAME);
        marker.zIndex = -999;
      }

      //DISEGNO CERCHIO
      const center = {
        lat: participant.position_cell_id.latitude,
        lng: participant.position_cell_id.longitude
      };

      // Opzioni grafiche del cerchio
      const circleOptions = {
        strokeColor: "#FF9800",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#FF9800",
        fillOpacity: 0.15,
        map: this.map,
        center: center,
        radius: participant.position_cell_id.accuracy,
        zIndex: 999
      };

      if (this.activeAccuracyCircle) {
        // Se esiste già, aggiorniamo solo posizione e raggio (evita sfarfallii)
        this.activeAccuracyCircle.setOptions(circleOptions);
      } else {
        // Se non esiste, lo creiamo
        this.activeAccuracyCircle = new GoogleMapsService.google.maps.Circle(circleOptions);
        this.googleMaps.addCircle(this.activeAccuracyCircle, this.MAP_NAME);
      }


      if (this.activeCellMarker) {
        this.activeCellMarker.position = center;
        if (!this.activeCellMarker.map) this.activeCellMarker.map = this.map;
      } else {
        this.activeCellMarker = new GoogleMapsService.google.maps.marker.AdvancedMarkerElement({
          map: this.map,
          position: center,
          content: GoogleMapsService.createYellowPinMarker(),
          zIndex: 500
        });
      }

      const contentString = `
      <div style="max-width: 250px; padding: 10px; font-family: Roboto, Arial, sans-serif;">
        <div style="display: flex; max-width: 220px; justify-content: space-between; align-items: center; margin-bottom: 8px; padding-bottom: 5px; border-bottom: 1px solid #eee;">
           <span style="font-weight: bold; color: #e65100; font-size: 14px;">${this.translate.instant('MAP.posizione_cella_gsm')}</span>
           <button id="custom-close-btn" style="background: none; border: none; font-size: 20px; line-height: 1; color: #888; cursor: pointer; padding: 0 0 0 10px;">
             &times;
           </button>
        </div>
        <div style="color: #333; font-size: 13px; line-height: 1.4;">
          ${this.translate.instant('MAP.info_cerchio_cella')}
        </div>
      </div>
    `;

      if (this.activeAccuracyInfoWindow) {
        this.activeAccuracyInfoWindow.setPosition(center);
        this.activeAccuracyInfoWindow.setContent(contentString);
        // this.activeAccuracyInfoWindow.open(this.map);
      } else {
        this.activeAccuracyInfoWindow = new GoogleMapsService.google.maps.InfoWindow({
          content: contentString,
          position: center,
          disableAutoPan: true,
          pixelOffset: new GoogleMapsService.google.maps.Size(0, -40)
        });

        this.activeAccuracyInfoWindow.addListener('domready', () => {
          const closeBtn = document.getElementById('custom-close-btn');
          if (closeBtn) {
            closeBtn.onclick = () => {
              if (this.activeAccuracyInfoWindow) {
                this.activeAccuracyInfoWindow.close();
              }
            };
          }
        });
      }

      this.activeCellMarker.addListener("click", () => {
        this.activeAccuracyInfoWindow.open(this.map);
      });


      //DISEGNO MARKER PER POSIZIONE (ultima posizione GPS valida).
      //Se virtualPosition e' 0,0 o mancante il GPS non ha mai fatto fix: NON disegno il marker rosso
      //ne' la sua InfoWindow (sarebbe sull'equatore, informazione fuorviante).
      //Se erano stati creati prima li nascondo/chiudo.
      const hasValidGps = participant.virtualPosition && participant.virtualPosition.latitude && participant.virtualPosition.longitude;
      if(hasValidGps){
        const center_pos = {
          lat: participant.virtualPosition.latitude,
          lng: participant.virtualPosition.longitude
        }

        if (this.tempMarker) {
          this.tempMarker.position = center_pos;
          if (!this.tempMarker.map) this.tempMarker.map = this.map;
        } else {
          this.tempMarker = new GoogleMapsService.google.maps.marker.AdvancedMarkerElement({
            map: this.map,
            position: center_pos,
            content: GoogleMapsService.createRedPinMarker(),
            zIndex: 400
          });
        }

        const contentTemp = `
        <div style="max-width: 250px; padding: 10px; font-family: Roboto, Arial, sans-serif;">
          <div style="display: flex; max-width: 220px; justify-content: space-between; align-items: center; margin-bottom: 8px; padding-bottom: 5px; border-bottom: 1px solid #eee;">
             <div></div>
             <button id="custom-close-btn-temp" style="background: none; border: none; font-size: 20px; line-height: 1; color: #888; cursor: pointer; padding: 0 0 0 10px;">
               &times;
             </button>
          </div>
          <div style="color: #333; font-size: 13px; line-height: 1.4;">
              ${this.translate.instant('MAP.ultima_pos_gps_valida')}
          </div>
        </div>
      `;

        if (this.tempInfoWindow) {
          this.tempInfoWindow.setPosition(center_pos);
          this.tempInfoWindow.setContent(contentTemp);
        } else {
          this.tempInfoWindow = new GoogleMapsService.google.maps.InfoWindow({
            content: contentTemp,
            position: center_pos,
            disableAutoPan: true,
            pixelOffset: new GoogleMapsService.google.maps.Size(0, -40)
          });

          this.tempInfoWindow.addListener('domready', () => {
            const closeBtn = document.getElementById('custom-close-btn-temp');
            if (closeBtn) {
              closeBtn.onclick = () => {
                if (this.tempInfoWindow) {
                  this.tempInfoWindow.close();
                }
              };
            }
          });
        }

        this.tempMarker.addListener("click", () => {
          this.tempInfoWindow.open(this.map);
        });
      }else{
        // GPS non valido (0,0 o mancante): rimuovi il marker rosso se esisteva e chiudi la info window.
        if(this.tempMarker) this.tempMarker.map = null;
        if(this.tempInfoWindow) this.tempInfoWindow.close();
      }


      const bounds = new GoogleMapsService.google.maps.LatLngBounds();

      // Aggiungi i confini del Cerchio (Cella)
      if (this.activeAccuracyCircle) {
        const circleBounds = this.activeAccuracyCircle.getBounds();
        if (circleBounds) {
          bounds.union(circleBounds);
        }
      }

      // Aggiungi la posizione del Veicolo (GPS) — solo se il marker rosso e' attualmente sulla mappa
      if (hasValidGps && this.tempMarker && this.tempMarker.position) {
        bounds.extend(this.tempMarker.position);
      }

      // Adatta la mappa per contenere tutto (con 50px di padding dai bordi)
      if (!bounds.isEmpty()) {
        this.map.fitBounds(bounds, 50);
      }

      DataService.api.getAddress(this.data.selOrganization.me._id, participant.position_cell_id.latitude, participant.position_cell_id.longitude).then((address: any)=>{
        participant.position_cell_id.address = address;
      }).catch((err: any) => {
        console.error(err)
      })

      if(hasValidGps){
        DataService.api.getAddress(this.data.selOrganization.me._id, participant.virtualPosition.latitude, participant.virtualPosition.longitude).then((address: any)=>{
          participant.virtualPosition.address = address;
        }).catch((err: any) => {
          console.error(err)
        })
      }

    } else {
      // Se siamo in modalità expand ma i dati cella mancano/sono spariti, rimuovi il cerchio
      this.removeCellIdCircle();
    }
  }

  private removeCellIdCircle() {
    if (this.activeAccuracyCircle) {
      this.activeAccuracyCircle.setMap(null);
      this.googleMaps.removeCircle(this.activeAccuracyCircle, this.MAP_NAME);
      this.activeAccuracyCircle = null;
    }

    if (this.tempMarker) {
      this.tempMarker.setMap(null);
      this.tempMarker = null;
    }

    // Rimuovi Label (InfoWindow)
    if (this.activeAccuracyInfoWindow) {
      this.activeAccuracyInfoWindow.close();
      this.activeAccuracyInfoWindow = null;
    }

    if (this.tempInfoWindow) {
      this.tempInfoWindow.close();
      this.tempInfoWindow = null;
    }

    if (this.expandedParticipantId) {
      const marker = this.participantMarkers.find(m => m.id === this.expandedParticipantId);
      if (marker) {
        // Lo rimetto sulla mappa
        this.googleMaps.showMarker(marker, this.MAP_NAME);
        // Mi assicuro che abbia lo stile corretto (se siamo ancora in expand)
        marker.zIndex = 1000;
      }
    }

    if (this.activeCellMarker) {
      this.activeCellMarker.map = null;
      this.activeCellMarker = null; // Distruggilo o riutilizzalo, qui lo distruggiamo per pulizia
    }
  }

}
